import { useCallback, useEffect, useState } from "react";

const useTabActive = () => {
    const [isTabActive, setIsTabActive] = useState(true);
    const [isTabVisible, seIsTabVisible] = useState(true);
    const [isTabFocused, setIsTabFocused] = useState(true);

    const handleActiveChange = useCallback((active: boolean) => {
        setIsTabActive(active);
    }, []);

    const handleVisibilityChange = useCallback(() => {
        seIsTabVisible(document.visibilityState === "visible");
    }, []);

    const handleFocus = useCallback(() => {
        setIsTabFocused(true);
    }, []);

    const handleBlur = useCallback(() => {
        setIsTabFocused(false);
    }, []);

    useEffect(() => {
        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("focus", handleFocus);
        window.addEventListener("blur", handleBlur);
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("focus", handleFocus);
            window.removeEventListener("blur", handleBlur);
        };
    }, []);

    useEffect(() => {
        if (isTabVisible && isTabFocused) {
            handleActiveChange(true);
        }
        if (!isTabVisible || !isTabFocused) {
            handleActiveChange(false);
        }
    }, [isTabVisible, isTabFocused]);

    return isTabActive;
};

export default useTabActive;
